import autoTable from "jspdf-autotable";
import { PDF_TABLE_STYLE, PDFCOLORSHEME } from "../../../../../../component/constent";

export function drawShopTable(doc, shop, rows, total) {
  let startY = doc.lastAutoTable
    ? doc.lastAutoTable.finalY + 20
    : 28;

  function format(value) {
    return Number(value || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  const columnStyles = {
    0: { cellWidth: 30, halign: "right" },
    1: { cellWidth: 40, halign: "right" },
    2: { cellWidth: 40, halign: "right" },
    3: { cellWidth: 40, halign: "right" },
    4: { cellWidth: 40, halign: "right" },
  };

  const pageHeight = doc.internal.pageSize.getHeight();

  if (startY > pageHeight - 25) {
    doc.addPage();
    startY = 28;
  }

  autoTable(doc, {
    startY,

    ...PDF_TABLE_STYLE,

    head: [[
      "Total Labour",
      "Total Store",
      "Freight",
      "Proforma",
      "TOTAL",
    ]],

    body: rows.map((row) => {

      // ================= LABOUR =================
      const totalLabour =
        Number(row["DIRECT LABOUR"] || 0) +
        Number(row["ON COST LABOUR"] || 0);


      // ================= STORE =================
      const totalStore =
        Number(row["ON COST STORE"] || 0) +
        Number(row["DIRECT STORE"] || 0);


      // ================= FREIGHT =================
      const freight =
        totalStore *
        (Number(row["StoreFreight"] || 0) / 100);


      // ================= PROFORMA =================
      const proforma =
        totalLabour *
        (Number(row["proformaoncost"] || 0) / 100);


      // ================= GRAND TOTAL =================
      const grandTotal =
        totalLabour +
        totalStore +
        freight +
        proforma;


      return [
        format(totalLabour),
        format(totalStore),
        format(freight),
        format(proforma),
        format(grandTotal),
      ];
    }),

    bodyStyles: {
      lineWidth: 0.3,
    },

    styles: {
      fontSize: PDFCOLORSHEME.FONT_SIZE_BODY,
      halign: "right",
    },

    headStyles: {
      fillColor: PDFCOLORSHEME.BACK_COLOR_HEADER,
      textColor: PDFCOLORSHEME.FONT_COLOR_HEADER,
      halign: "center",
      fontStyle: "bold",
    },

    columnStyles,
  });


  // ================= SHOP TOTAL =================

  const y = doc.lastAutoTable.finalY + 2;

  doc.setFillColor(PDFCOLORSHEME.BACK_COLOR_TOTAL);
  doc.rect(14, y, 190, 8, "F");

  doc.setTextColor(PDFCOLORSHEME.FONT_COLOR_TOTAL);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(PDFCOLORSHEME.FONT_SIZE_TOTAL);

  
  // Total Labour
  doc.text(format(total.TotalLabour), 40, y + 5, {
    align: "right",
  });

  // Total Store
  doc.text(format(total.TotalStore), 85, y + 5, {
    align: "right",
  });

  // Freight
  doc.text(format(total.Freight), 120, y + 5, {
    align: "right",
  });

  // Proforma
  doc.text(format(total.Proforma), 165, y + 5, {
    align: "right",
  });

  // Grand Total
  doc.text(format(total.GrandTotal), 195, y + 5, {
    align: "right",
  });

  // Reset text color
  doc.setTextColor(0);

  // Reserve space after total
  doc.lastAutoTable.finalY = y + 5;
}